<template>
    <b-dropdown
        :variant="variant"
        class="video-seek-mode-selector"
        :text="$translate(videoSeekMode)"
        :boundary="boundary"
    >
        <b-dropdown-item href="#" @click.stop="changeSeekMode(VIDEO_SEEK_MODES.TIME)">
            {{ $translate(VIDEO_SEEK_MODES.TIME) }}
        </b-dropdown-item>

        <b-dropdown-item
            v-if="!isFdaFriendly"
            href="#"
            @click.stop="changeSeekMode(VIDEO_SEEK_MODES.MK_EVENT)"
        >
            {{ $translate(VIDEO_SEEK_MODES.MK_EVENT) }}
        </b-dropdown-item>

        <b-dropdown-item href="#" @click.stop="changeSeekMode(VIDEO_SEEK_MODES.ISTANBUL_EVENT)">
            {{ $translate(VIDEO_SEEK_MODES.ISTANBUL_EVENT) }}
        </b-dropdown-item>

        <b-dropdown-item href="#" @click.stop="changeSeekMode(VIDEO_SEEK_MODES.DAY)">
            {{ $translate(VIDEO_SEEK_MODES.DAY) }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { VIDEO_SEEK_MODES } from '../../../business/const'
import { mapGetters } from 'vuex'

export default {
    name: 'VideoSeekModeSelector',
    props: {
        variant: {
            type: String,
            required: true
        },
        videoSeekMode: {
            type: String,
            required: true
        },
        // ref : https://bootstrap-vue.org/docs/components/dropdown#boundary-constraint
        boundary: {
            type: String,
            default: 'scrollParent'
        }
    },
    data() {
        return {
            VIDEO_SEEK_MODES
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        })
    },
    methods: {
        changeSeekMode(value) {
            if (value !== this.videoSeekMode) {
                this.$emit('videoSeekModeChanged', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.video-seek-mode-selector {
    width: 7rem;
    padding: 0;
}
</style>
